export default {
  title: 'Filter Settings',
  timeInterval: 'Time interval',
  additionalFilters: 'Additional Filters',
  noWeekdaysNotification: 'At least one day of the week should be chosen',
  lagging: {
    lagging: 'Lagging',
    isLagging: {
      true: 'Detected only',
      false: 'Stopped only',
    },
    all: 'Detected and stopped',
  },
  newState: 'New state',
  assignee: 'Assigned to',
  created: 'Created by',
};
